import { ElementRef } from '@angular/core';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app-state.index';
import { setBlockDocument, setCurrentPageTitle, setDisplayLoginDialog, setDivElement, setIsLoading } from '../state/actions/‏‏shared-common.action';
import { HttpClient } from '@angular/common/http';
import { DecodingTokenModel } from '../model/decoding-token.model';
@Injectable()
export class CommonService {

  constructor(private store: Store<AppState>, private httpClient: HttpClient) {
  }

  public handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);

  }
  public displayLoadingIndicator(divElement?: any) {
    this.setIsLoading(true, divElement);
  }

  public blockScreen(blockDocument: boolean) {
    this.store.dispatch(setBlockDocument({ blockDocument }));
  }

  public clearLoadingIndicator() {
    this.setIsLoading(false);
  }

  public changeCurrentPageHeader(pageTitle: string) {
    this.store.dispatch(setCurrentPageTitle({ displayPageTitle: true, pageTitle }));

  }
  public clearCurrentPageHeader() {
    this.store.dispatch(setCurrentPageTitle({ displayPageTitle: false }));
  }
  private setIsLoading(isLoading: boolean, divElement?: ElementRef) {
    this.store.dispatch(setIsLoading({ isLoading, divElement }));
  }
  getIsraelCities() {
    return this.httpClient.get('https://raw.githubusercontent.com/royts/israel-cities/master/israel-cities.json', { headers: { 'Do-Not-Add-Headers': 'true', } });
  }
  getCountriesList() {
    return this.httpClient.get('https://data.gov.il/api/3/action/datastore_search?resource_id=c84082e9-7d45-4853-9a95-e7eaad7f66d5&limit=254', { headers: { 'Do-Not-Add-Headers': 'true', } });
  }
  decodingToken(request: DecodingTokenModel) {
    return this.httpClient.post('/Clearing/DecodingToken', request);
  }
    exportCustomersToExcel(bussinessId: number, filter: any,Paging: any) {
    return this.httpClient.post('/webroulette/exportToExcel', {
      bussinessId,
      filter,
      Paging,
    },
      { responseType: "blob", headers: { Accept: 'application/octet-stream' } })
  }
  exportBusinessCouponToExcel(bussinessId: number, filter: any,Paging: any)
  {
    return this.httpClient.post('/webroulette/exportCouponsToExcel', {
      bussinessId,
      filter,
      Paging,
    },
      { responseType: "blob", headers: { Accept: 'application/octet-stream' } })
  }
}
